var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-page-content-template',{attrs:{"title":"Dr.AI ヘルスケア & エステ","subtitle":"64歳以下コース"}},[_c('result',{attrs:{"question-tree":_vm.questionTree,"answer-to-sound-src":_vm.answerToSoundSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }